/**
 * Dedicated Axios client for Auth BFF (testdevauth / auth).
 * Do not reuse the Backend `/api` instance — BFF must not inject body `client`.
 */
import axioss from 'axios';
import { getAuthBffUrl, isAuthBffConfigured, joinServiceUrl } from './serviceUrls';

const authBff = axioss.create({
  baseURL: getAuthBffUrl() || undefined,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export { isAuthBffConfigured, getAuthBffUrl };

authBff.interceptors.request.use(
  function (config) {
    const serviceBase = getAuthBffUrl();
    if (serviceBase && config.url && !/^https?:\/\//i.test(config.url)) {
      config.url = joinServiceUrl(serviceBase, config.url);
      config.baseURL = undefined;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

authBff.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default authBff;
